﻿﻿import { CancerType } from '../enums/index';
import { RemissionStatus } from '../enums/index';

export interface ICancerHistory {
    cancerType: CancerType;
    remissionStatus: RemissionStatus;
}
